import React from "react";

export const LazyLoggedOutSignUpMiniDrawer = React.lazy(() =>
  import(
    /* webpackChunkName: "logged-out-sign-up-mini-drawer" */ "./LoggedOutSignUpMiniDrawer"
  ).then((m) => ({ default: m.LoggedOutSignUpMiniDrawer }))
);
